import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { GlobalVariableService } from '../../Shared/global-variable.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MaterialModule } from 'src/app/Shared/Material/material.module';
@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent implements OnInit {
  public txtColor;
  public bgColor;
  public hvCard;
  public showProfile = false;
  public profInit = false;

  public personaldetails: any = [[]];
  public accountdetails: any = [[]];
  public taxstatus = "";
 public jointholder = "";
 public nomineee = "";
  constructor(private _globalVariableService: GlobalVariableService, private spinnerService: NgxSpinnerService, ) {
    this.bgColor = this._globalVariableService.bgColor;
    this.txtColor = this._globalVariableService.color;
    this.hvCard = this._globalVariableService.hvCard;
    this._globalVariableService.pageTitle = "profile";
  }
  ngOnInit() {
    this._globalVariableService.profBhSubject.subscribe((data) => {
      if (data) {
        this.loadProfile(data);
      } else {
        this.showProfile = false;
      }
    });
  }

  ngOnDestroy() {
    // this._globalVariableService.profBhSubject.unsubscribe();
  }

  loadProfile(data) {
    this.personaldetails = data.detail1;
    this.taxstatus = this.personaldetails[0].TAX_STATUS_DESC
    var nameArr =  this.personaldetails[0].JH1_NAME.split(',');
    for (let i = 0; i < this.personaldetails.length; i++) {
      if (this.personaldetails[i].JH1_NAME == "NA") {
        this.jointholder = "Not Applicable";
      }
      else if (nameArr[1] == "") {
        this.jointholder = nameArr[0];
      }
      else {
        this.jointholder = this.personaldetails[i].JH1_NAME
      }
      if (this.personaldetails[i].NM1_NAME == "NA") {
        this.nomineee = "Not Applicable";
      }
      else {
        this.nomineee = this.personaldetails[i].NM1_NAME
      }
      }
     
   
    this.accountdetails[0] = data.detail[0];
    this.showProfile = true;
    this.profInit = true;
  }

}